export default {
    baseStyle: {
        marginBottom: '9px',
        fontSize: 'md',
        fontWeight: '700',
        lineHeight: '18px',
        fontFamily: 'DM Sans'
    }
}
